import * as React from 'react';
import { Box } from '@material-ui/core';
import { BokunLogo } from '../../BokunLogo/BokunLogo';
import TripadvisorLogo from '../../../assets/tripadvisor-logo-black.svg';

export const LeftFooter: React.FC = () => {
    return (
        <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'space-between'}
            style={{ maxWidth: '60%' }}
        >
            <Box>
                <Box>
                    <BokunLogo />
                </Box>
                <Box py={1} pb={0} fontSize={'26px'} color="secondary.main">
                    We know tours & activites
                </Box>
                <Box py={1} pb={0} fontSize={'14px'} color="secondary.main">
                    We provide a fast, scalable, affordable SaaS platform for suppliers in the
                    experiences industry.
                </Box>

                <Box fontSize={'14px'} pb={1} color="secondary.main" marginTop="2em">
                    Bókun is a
                    <img
                        style={{
                            marginRight: '8px',
                            marginLeft: '8px',
                            position: 'relative',
                            top: 5,
                        }}
                        src={TripadvisorLogo}
                        className="AppLogo"
                        alt={'Tripadvisor'}
                    />
                    company
                </Box>
            </Box>
        </Box>
    );
};
